import { useFetchLatestAppoinmentResults } from '@/api/hooks/useFetchLatestAppointmentResults'
import WavyUnderline from '@/components/svgs/WavyUnderline'
import { Dialog, DialogClose, DialogContent, DialogTrigger } from '@/ui/core/dialog'
import { HStack, VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'
import { Pressable } from '@/ui/primitives/slot'
import { cn } from '@/ui/utils'
import { Link, usePathname } from 'expo-router'
import { useWindowDimensions } from 'react-native'

const MobileNavigationMenu = () => {
	const pathname = usePathname()
	const { hasAppointmentResults, isLoadingResults } = useFetchLatestAppoinmentResults()

	if (isLoadingResults) {
		return null
	}

	return (
		<Dialog>
			<DialogTrigger asChild>
				<Pressable className="p-8 native:top-6 z-30">
					<Text
						className={cn(pathname === '/profile' ? 'text-palette_5' : 'text-palette_3')}
						spacing="wide"
						size="2xl"
					>
						MENU
					</Text>
				</Pressable>
			</DialogTrigger>
			<DialogContent variant="nav" contentClassName="w-full">
				<VStack className="justify-center items-center" gap={24}>
					<DialogClose asChild>
						<Link href="/">
							<Text className="text-white text-3xl" spacing="wide" weight="bold">
								HOME
							</Text>
						</Link>
					</DialogClose>
					<DialogClose asChild>
						<Link href="/billing">
							<Text className="text-white text-3xl" spacing="wide" weight="bold">
								BILLING
							</Text>
						</Link>
					</DialogClose>
					<DialogClose asChild>
						<Link href="/profile">
							<Text className="text-white text-3xl" spacing="wide" weight="bold">
								PROFILE
							</Text>
						</Link>
					</DialogClose>
					{hasAppointmentResults && (
						<DialogClose asChild>
							<Link href="/my-smile">
								<Text className="text-white text-3xl" spacing="wide" weight="bold">
									MY SMILE
								</Text>
							</Link>
						</DialogClose>
					)}
				</VStack>
			</DialogContent>
		</Dialog>
	)
}

const LargeNavigationView = () => {
	const pathname = usePathname()
	const { hasAppointmentResults, isLoadingResults } = useFetchLatestAppoinmentResults()

	if (isLoadingResults) {
		return null
	}

	return (
		<HStack gap={36} className="z-30 pr-8">
			<Link href="/">
				<VStack className="items-center">
					<Text className="text-xl" spacing="wide">
						HOME
					</Text>
					{pathname === '/' && <WavyUnderline width={'100%'} />}
				</VStack>
			</Link>
			<Link href="/billing">
				<VStack className="items-center">
					<Text className="text-xl" spacing="wide">
						BILLING
					</Text>
					{pathname === '/billing' && <WavyUnderline width={'100%'} />}
				</VStack>
			</Link>
			<Link href="/profile">
				<VStack className="items-center">
					<Text className="text-xl" spacing="wide">
						PROFILE
					</Text>
					{pathname === '/profile' && <WavyUnderline width={'100%'} />}
				</VStack>
			</Link>
			{hasAppointmentResults && (
				<Link href="/my-smile">
					<VStack className="items-center">
						<Text className="text-xl" spacing="wide">
							MY SMILE
						</Text>
						{pathname === '/my-smile' && <WavyUnderline width={'100%'} />}
					</VStack>
				</Link>
			)}
		</HStack>
	)
}

const AppNavigation = () => {
	const { width } = useWindowDimensions()

	const showMobileNav = width < 800

	return (
		<>
			{showMobileNav && <MobileNavigationMenu />}
			{!showMobileNav && <LargeNavigationView />}
		</>
	)
}

export { AppNavigation }
